import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FooterComponent } from '../../home/home/footer/footer.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../service/api/api.service';
import { NgSelectModule } from '@ng-select/ng-select';

interface ExperienceOption {
  label: string;
  value: number;
}

@Component({
  selector: 'app-inscription-etape',
  standalone: true,
  templateUrl: './inscription-etape.component.html',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule],
})
export class InscriptionEtapeComponent implements OnInit, OnDestroy {
  reactiveForm_add_utilisateur !: FormGroup;
  submitted: boolean = false
  loading_add_utilisateur: boolean = false
  form_details: any = {}
  showpassword: boolean = false
  loading_get_details_add_utilisateur_form = false
  experienceOptions: ExperienceOption[] = [];
anneesNaissance: number[] = [];

  constructor(private formBuilder: FormBuilder, public api: ApiService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    console.groupCollapsed("AddUtilisateurComponent");
    this.get_details_add_utilisateur_form()
    this.init_form()
    const currentYear = new Date().getFullYear();
    for (let year = currentYear - 18; year >= 1950; year--) {
    this.anneesNaissance.push(year);
  }
    this.experienceOptions = [
      { label: 'Moins de 1 an', value: currentYear },
      { label: '1 à 5 ans', value: currentYear - 3 },
      { label: '5 à 10 ans', value: currentYear - 7 },
      { label: 'Plus de 10 ans', value: currentYear - 15 }
    ];
  }
  ngOnDestroy(): void {
    console.groupEnd();
  }
  init_form() {
    this.reactiveForm_add_utilisateur = this.formBuilder.group({
      telephone: ["", Validators.required],
      // email: [""],
      id_privilege: ["3", Validators.required],
      id_genre: [""],
      id_statut_utilisateur: ["1",Validators.required],
      nom: ["", Validators.required],
      adresse: [""],
      password: ["",Validators.required],
      photo_profil: [""],
      annee_naissance: ["",Validators.required],
      annee_debut_conduite: ["",Validators.required],
    });
  }

  // acces facile au champs de votre formulaire
  get f(): any { return this.reactiveForm_add_utilisateur.controls; }
  // validation du formulaire
  onSubmit_add_utilisateur() {
    this.submitted = true;
    // console.log(this.reactiveForm_add_utilisateur.value)
    // stop here if form is invalid
    if (this.reactiveForm_add_utilisateur.invalid) {
      return;
    }
    var utilisateur = this.reactiveForm_add_utilisateur.value
    // console.log("Valeurs du formulaire add_utilisateur: ", utilisateur);
    this.add_utilisateur(utilisateur)
  }
  // vider le formulaire
  onReset_add_utilisateur() {
    this.submitted = false;
    this.reactiveForm_add_utilisateur.reset();
  }
  add_utilisateur(utilisateur: any) {
    this.loading_add_utilisateur = true;
    this.api.taf_post("utilisateur/add2", utilisateur, (reponse: any) => {
      this.loading_add_utilisateur = false;
      if (reponse.status) {
        // console.log("Opération effectuée avec succés sur la table utilisateur. Réponse= ", reponse);
        this.onReset_add_utilisateur()
        this.api.Swal_success("Opération éffectuée avec succés")
        this.activeModal.close(reponse)
      } else {
        // console.log("L'opération sur la table utilisateur a échoué. Réponse= ", reponse);
        this.api.Swal_error("L'opération a echoué")
      }
    }, (error: any) => {
      this.loading_add_utilisateur = false;
    })
  }

  get_details_add_utilisateur_form() {
    this.loading_get_details_add_utilisateur_form = true;
    this.api.taf_post("utilisateur/get_form_details", {}, (reponse: any) => {
      if (reponse.status) {
        this.form_details = reponse.data
        // console.log("Opération effectuée avec succés sur la table utilisateur. Réponse= ", reponse);
      } else {
        // console.log("L'opération sur la table utilisateur a échoué. Réponse= ", reponse);
        this.api.Swal_error("L'opération a echoué")
      }
      this.loading_get_details_add_utilisateur_form = false;
    }, (error: any) => {
      this.loading_get_details_add_utilisateur_form = false;
    })
  }
  shoow_hide_password() {
    this.showpassword = !this.showpassword
  }
}
